// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmploymentProfileDto
 */
export interface IEmploymentProfileDto {
    /**
     * 
     * @type {string}
     * @memberof IEmploymentProfileDto
     */
    position?: IEmploymentProfileDtoPositionEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmploymentProfileDto
     */
    employment_type?: IEmploymentProfileDtoEmploymentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IEmploymentProfileDto
     */
    broker?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmploymentProfileDto
     */
    director_of?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmploymentProfileDto
     */
    politically_exposed_names?: string;
}

/**
* @export
* @enum {string}
*/
export enum IEmploymentProfileDtoPositionEnum {
    ACCOUNTANT = 'ACCOUNTANT',
    ACTUARY = 'ACTUARY',
    ADJUSTER = 'ADJUSTER',
    ADMINISTRATOR = 'ADMINISTRATOR',
    ADVERTISER = 'ADVERTISER',
    AGENT = 'AGENT',
    ATC = 'ATC',
    AMBASSADOR = 'AMBASSADOR',
    ANALYST = 'ANALYST',
    APPRAISER = 'APPRAISER',
    ARCHITECT = 'ARCHITECT',
    ARTIST = 'ARTIST',
    ASSISTANT = 'ASSISTANT',
    ATHLETE = 'ATHLETE',
    ATTENDANT = 'ATTENDANT',
    ATTORNEY = 'ATTORNEY',
    AUCTIONEER = 'AUCTIONEER',
    AUDITOR = 'AUDITOR',
    BARBER = 'BARBER',
    BROKER = 'BROKER',
    BUSINESS_EXEC = 'BUSINESS_EXEC',
    BUSINESS_OWNER = 'BUSINESS_OWNER',
    CAREGIVER = 'CAREGIVER',
    CARPENTER = 'CARPENTER',
    CASHIER = 'CASHIER',
    CHEF = 'CHEF',
    CHIROPRACTOR = 'CHIROPRACTOR',
    CIVIL = 'CIVIL',
    CLERGY = 'CLERGY',
    CLERK = 'CLERK',
    COMPLIANCE = 'COMPLIANCE',
    CONSULTANT = 'CONSULTANT',
    CONTRACTOR = 'CONTRACTOR',
    COUNSELOR = 'COUNSELOR',
    CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
    DEALER = 'DEALER',
    DEVELOPER = 'DEVELOPER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    DOCTOR = 'DOCTOR',
    DRIVER = 'DRIVER',
    ENGINEER = 'ENGINEER',
    EXAMINER = 'EXAMINER',
    EXTERMINATOR = 'EXTERMINATOR',
    FACTORY = 'FACTORY',
    FARMER = 'FARMER',
    FINANCIAL = 'FINANCIAL',
    FISHERMAN = 'FISHERMAN',
    FLIGHT = 'FLIGHT',
    HR = 'HR',
    IMPEX = 'IMPEX',
    INSPECTOR = 'INSPECTOR',
    INTERN = 'INTERN',
    INVESTMENT = 'INVESTMENT',
    INVESTOR = 'INVESTOR',
    IT = 'IT',
    JANITOR = 'JANITOR',
    JEWELER = 'JEWELER',
    LABORER = 'LABORER',
    LANDSCAPER = 'LANDSCAPER',
    LENDING = 'LENDING',
    MANAGER = 'MANAGER',
    MECHANIC = 'MECHANIC',
    MILITARY = 'MILITARY',
    MORTICIAN = 'MORTICIAN',
    NURSE = 'NURSE',
    NUTRITIONIST = 'NUTRITIONIST',
    OFFICE = 'OFFICE',
    PHARMACIST = 'PHARMACIST',
    PHYSICAL = 'PHYSICAL',
    PILOT = 'PILOT',
    POLICE = 'POLICE',
    POLITICIAN = 'POLITICIAN',
    PM = 'PM',
    REP = 'REP',
    RESEARCHER = 'RESEARCHER',
    SAILOR = 'SAILOR',
    SALES = 'SALES',
    SCIENTIST = 'SCIENTIST',
    SEAMSTRESS = 'SEAMSTRESS',
    SECURITY = 'SECURITY',
    SOCIAL = 'SOCIAL',
    TEACHER = 'TEACHER',
    TECHNICIAN = 'TECHNICIAN',
    TELLER = 'TELLER',
    TRADESPERSON = 'TRADESPERSON',
    TRAINER = 'TRAINER',
    TRANSPORTER = 'TRANSPORTER',
    UNDERWRITER = 'UNDERWRITER',
    WRITER = 'WRITER'
}
/**
* @export
* @enum {string}
*/
export enum IEmploymentProfileDtoEmploymentTypeEnum {
    AGRICULTURE = 'AGRICULTURE',
    MINING = 'MINING',
    UTILITIES = 'UTILITIES',
    CONSTRUCTION = 'CONSTRUCTION',
    MANUFACTURING = 'MANUFACTURING',
    WHOLESALE = 'WHOLESALE',
    RETAIL = 'RETAIL',
    TRANSPORT = 'TRANSPORT',
    INFORMATION = 'INFORMATION',
    FINANCE = 'FINANCE',
    REAL_ESTATE = 'REAL_ESTATE',
    PROFESSIONAL = 'PROFESSIONAL',
    MANAGEMENT = 'MANAGEMENT',
    EDUCATION = 'EDUCATION',
    HEALTH = 'HEALTH',
    ART = 'ART',
    FOOD = 'FOOD',
    PUBLIC = 'PUBLIC',
    WASTE = 'WASTE'
}


/**
 * Check if a given object implements the IEmploymentProfileDto interface.
 */
export function instanceOfIEmploymentProfileDto(value: object): value is IEmploymentProfileDto {
    return true;
}

export function IEmploymentProfileDtoFromJSON(json: any): IEmploymentProfileDto {
    return IEmploymentProfileDtoFromJSONTyped(json, false);
}

export function IEmploymentProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmploymentProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'] == null ? undefined : json['position'],
        'employment_type': json['employment_type'] == null ? undefined : json['employment_type'],
        'broker': json['broker'] == null ? undefined : json['broker'],
        'director_of': json['director_of'] == null ? undefined : json['director_of'],
        'politically_exposed_names': json['politically_exposed_names'] == null ? undefined : json['politically_exposed_names'],
    };
}

export function IEmploymentProfileDtoToJSON(json: any): IEmploymentProfileDto {
    return IEmploymentProfileDtoToJSONTyped(json, false);
}

export function IEmploymentProfileDtoToJSONTyped(value?: IEmploymentProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'employment_type': value['employment_type'],
        'broker': value['broker'],
        'director_of': value['director_of'],
        'politically_exposed_names': value['politically_exposed_names'],
    };
}

